import React from "react";
import styles from "./witch-skill.module.css";
import { Page } from "../../../components/page/page";
import { ContinueButton } from "../../../../../components/continue-button/continue-button";

const WitchSkillPage = () => {
  const buttonStyles = {
    backgroundColor: "#ffffff",
    color: "#2C403D",
    position: 'relative',
    zIndex: '1'
  };
  return (
    <div className={styles.page}>
      <Page
        title={["In many traditions, a ", <span>witch's</span>, " power is believed to be passed down through generations, though some view it as a skill that can also be learned or discovered independently"]}
        hideSteps="true"
        hideContinueButton="true"
      >
        <ContinueButton
          link="../intuitive-healing"
          additionalClassName={styles.button}
          buttonStyles={buttonStyles}
        ></ContinueButton>
      </Page>
    </div>
  );
};

export { WitchSkillPage };
